import React, { Component, Fragment } from 'react';
import InitialSelector from './InitialSelector';
import AddressSelector from './AddressSelector';
import PersistenceManager from '../../../functions/persistence';
import Decorator from '../../../functions/decorator';
import RecurveBaseComponent from '../../../base_components/RecurveBaseComponent';
import RecurveUtility from '../../../functions/utility';
import FutureOrderSelector from "../checkout/FutureOrderSelector";

export default class ServiceTypeSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chosenServiceType: {
                id: -99,
                name: 'none',
                promptForAddress: false
            },
            doneButtonEnabled: false,
            showSelectorButtons: true,
            cancelButtonEnabled: true,
            isFutureOrder: false,
            showAddressSelector: false,
            error: null,
            hasServerError: false,
            hasPopupError: false,
            fetching: false, // Like loading variable, but displays spinner inline
            showOrderTimingSelector: false,
            currentServiceType : {},
            is_curbside_order: false,
            showCurbsideInfo: false,
            curbside_sms: '',
            curbsideNextButtonEnabled: false
        };
        this.utility = {...RecurveUtility};
        this.modalRef = React.createRef();
        this.selectServiceType = this.selectServiceType.bind(this);
        this.selectAddress = this.selectAddress.bind(this);
        this.goBackToInitialScreen = this.goBackToInitialScreen.bind(this);
        this.postServiceType = this.postServiceType.bind(this);
        this.setAddressID = this.setAddressID;
        this.id = 'serviceTypePanel';
        this.closeServiceTypeSelector = this.closeServiceTypeSelector.bind(this);
        this.setError = this.setError.bind(this);
        this.clearError = this.clearError.bind(this);
        this.resetServiceTypeSelector = this.resetServiceTypeSelector.bind(this);
        this.promptForServiceTypes = this.promptForServiceTypes.bind(this);
        this.promptForFutureOrders = this.promptForFutureOrders.bind(this);
        this.closeFutureOrderSelector = this.closeFutureOrderSelector.bind(this);
        this.handleAsapPressed = this.handleAsapPressed.bind(this);
        this.handleFutureTimeChosen = this.handleFutureTimeChosen.bind(this);
        this.handleBackOnFutureTimePressed = this.handleBackOnFutureTimePressed.bind(this);
        this.interimStep = this.interimStep.bind(this);
        this.finalStep = this.finalStep.bind(this);
        this.completeCurbside = this.completeCurbside.bind(this);
        this.updateCurbsideSms = this.updateCurbsideSms.bind(this);
    }

    handleBackOnFutureTimePressed()
    {
        this.setState({
            showFutureOrderSelector: false,
        })
    }

    promptForServiceTypes() {
        this.setState({showServiceTypeSelector: true, showDiscounts: false});
    }

    closeServiceTypeSelector() {
        this.setState({showServiceTypeSelector: false, showDiscounts: true});
    }

    promptForFutureOrders() {
        this.setState({showFutureOrderSelector: true});
    }

    closeFutureOrderSelector() {
        this.setState({showFutureOrderSelector: false});
    }


    setError(err, isServerError) {
        this.setState({error: err, hasServerError: isServerError, fetching: false, hasPopupError: true});
    }

    clearError() {
        if(this.state.error || this.state.hasServerError) {
            this.setState({error: null, hasServerError: false, hasPopupError: false});
        }
    }

    closeServiceTypeSelector(name) {
        // window.$(`#serviceTypePanel`).modal('hide');
        // $('.modal-backdrop').remove();
        // $('body').removeClass('modal-open');
        this.state.chosenServiceType.name === 'Delivery' && !this.state.address ? window.location.reload() : null;
        location.href = document.referrer
    }

    componentDidMount() {
        Decorator.scrollTop();
        // Grabs service types avaialble from the server here
        // This is called on the itemCustomize page
        let url =  window.relativeURI() + '/store/service_types/api';
        fetch(url, {method: 'GET'}).then( (response, rejection) => {
            if(response.status > 300 && response.status < 400) document.location.reload(); //Follow redirects
            if(response.ok) {
                response.json().then( (resJSON) => {
                    this.setState({serviceTypes: resJSON}, () => {
                        window.$(`#${this.id}`).modal('show');
                    });
                }, (jsonFailure) => {
                    this.setError({name: 'Response Format Error', description: 'unknown error response'}, hasServerError);
                })
            }else {
                let hasServerError = response.status >= 500;
                response.json().then( (errorJSON) => {
                    this.setError(errorJSON, hasServerError)
                }, (jsonFailure) => {
                    this.setError({name: 'Server Error', description: 'unknown error'}, hasServerError);
                })
            }
        });
    }

    selectServiceType(serviceType, is_curbside_order)
    {
        this.interimStep(serviceType, is_curbside_order);
    }

    interimStep(serviceType, is_curbside_order) // store things while we wait for user to decide if they will place order for asap or future.
    {
        if(is_curbside_order) {
            this.setState({
                is_curbside_order: is_curbside_order,
                showCurbsideInfo: is_curbside_order,
                showSelectorButtons: false,
                currentServiceType: serviceType
            });
        }
        else {
            this.setState({
                isFutureOrder: true,
                showSelectorButtons: false,
                currentServiceType : serviceType
            });
        }

    }

    updateCurbsideSms(e) {
        let sms_num = e.target.value;
        let clean_sms = sms_num.replace(/[^0-9\\.]+/g, '');
        if(clean_sms.length > 10) {
            this.setState({
                sms_error: `Phone number must be only 10 digits.`
            }, () => {
                $('#curbside_sms').val(this.state.curbside_sms);
            })
        }
        else {
            this.setState({
                sms_error: null,
                curbside_sms: clean_sms
            }, () => {
                $('#curbside_sms').val(sms_num.replace(/[^0-9\\.]+/g, ''));
                if(this.state.curbside_sms.length === 10) {
                    this.setState({
                        curbsideNextButtonEnabled: true
                    })
                }
                else {
                    this.setState({
                        curbsideNextButtonEnabled: false
                    })
                }
            });
        }
    }

    completeCurbside() {
        this.setState({
            showCurbsideInfo: false,
            isFutureOrder: true,
        })
    }

    handleAsapPressed()
    {
        PersistenceManager.setDeferDateTime(null);
        PersistenceManager.setIsDeferredFalse();
        this.finalStep();
    }

    handleFutureTimeChosen()
    {
        PersistenceManager.setIsDeferredTrue();
        this.finalStep();
    }

    finalStep()
    {
        let serviceType = this.state.currentServiceType;
        this.setState({chosenServiceType: serviceType, showAddressSelector: true, isFutureOrder: false, showSelectorButtons: true}, () => {
            if(serviceType.pos_id != 1) {//Do this for all service types except delivery
                this.postServiceType();
            }
        });
    }

    postServiceType(address) {
        PersistenceManager.holdServiceTypeInSession(JSON.stringify(this.state.chosenServiceType));
        PersistenceManager.holdCurbsideSms(JSON.stringify(this.state.curbside_sms));
        let is_curbside_order = this.state.curbside_sms !== '' ? 'true' : 'false';
        PersistenceManager.setCurbideOrderStatus(is_curbside_order);
        if(this.state.fetching) return true;
        this.clearError();
        //Post service type and additional address information if necessary, referencing this.state
        let payload;
        if(address) {
            payload = {
                service_type_id: this.state.chosenServiceType.id,
                address: address.address,
                address2: address.address2,
                city: address.city,
                state: address.state,
                zip: address.zip,
                is_deferred: PersistenceManager.isDeferDateSet(),
                curbside_sms: this.state.is_curbside_order ? this.state.curbside_sms : null
            };
        }else {
            payload = {
                service_type_id: this.state.chosenServiceType.id,
                is_deferred: PersistenceManager.isDeferDateSet(),
                curbside_sms: this.state.is_curbside_order ? this.state.curbside_sms : null
            }
        }
        let cb = (name) => {
            // Called to update the popup when we've successfully posted
            this.closeServiceTypeSelector(name);
        };
        let url = window.relativeURI() + '/cart/setServiceType/api';
        let headers = new Headers({
            'X-CSRF-TOKEN': window.session.token,
            'credentials': 'same-origin',
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest"});
        this.setState({fetching: true, errorMessages: []}, () => {
            fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            }).then( (serverResponse) => {
                if(serverResponse.status > 300 && serverResponse.status < 400) document.location.reload(); //Follow redirects
                this.setState({fetching: false});
                if(serverResponse.ok) {
                    cb(this.state.chosenServiceType.name);
                    if(this.props.updateFunction) {
                        this.props.updateFunction(this.state.chosenServiceType, address);
                    }
                }else {
                    let hasServerError = serverResponse.status >= 500;

                    serverResponse.json().then( (failureReason) => {
                        this.setError(failureReason, hasServerError);
                    }, (jsonParseRejection) => {
                        let error = {name: 'Unknown Error', description: jsonParseRejection};
                        this.setError(error, hasServerError);
                    })
                }

            }, (fetchFailure) => {
                console.log('fetch failed');
                console.log(fetchFailure);
            });
        });
    }

    selectAddress(address) {
        this.setState({address: address});
    }

    goBackToInitialScreen() {
        return new Promise( (resolve, reject) => {
            try {
                this.setState({showAddressSelector: false, fetching: false}, () => {
                    resolve();
                });
            }catch (err) {
                reject(err);
            }
        })

    }

    setAddressID(id) {
        PersistenceManager.setAddressID(id);
    }

    resetServiceTypeSelector() {
        this.clearError();
        return new Promise( (resolve, reject) => {
            try {
                let showModal = () => {
                    window.$(`#serviceTypePanel`).modal('show');
                };
                this.goBackToInitialScreen().then( () => {
                    showModal();
                    resolve();
                }).catch( (err) => {
                    console.log(err);
                    reject(err);
                })
            }catch(err) {
                console.log(err);
                reject(err);
            }
        });

    }

    render() {
        let deferredOrder =
            <div className="row align-content-center justify-content-center">
                <FutureOrderSelector
                    isFutureOrder={this.props.isFutureOrder}
                    handleChangeInOrderDate={this.props.handleChangeInOrderDate}
                    handleChangeInOrderTime={this.props.handleChangeInOrderTime}
                    cancelFutureOrderTiming={this.props.cancelFutureOrderTiming}
                    futureOrderDate={this.props.futureOrderDate}
                    futureOrderTime={this.props.futureOrderTime}
                    promptForFutureOrders={this.promptForFutureOrders}
                    closeFutureOrderSelector={this.closeFutureOrderSelector}
                    showSelector={this.state.showFutureOrderSelector}
                    deferOrder={this.props.deferOrder}
                    deferDateTime={this.props.deferDateTime}
                    asapPressed={this.handleAsapPressed}
                    handleFutureTimeChosen={this.handleFutureTimeChosen}
                    handleBackOnFutureTimePressed={this.handleBackOnFutureTimePressed}
                    selectedServiceType={this.state.currentServiceType}
                />
            </div>;
        let addressSelector =
            <AddressSelector
                serviceType={this.state.chosenServiceType}
                setAddressID={this.setAddressID}
                userAuthenticated={window.session.user_authenticated && !window.session.is_guest}
                isDialog={true} goBack={this.goBackToInitialScreen}
                selectAddress={this.selectAddress}
                postServiceType={this.postServiceType}
                deferredSelector={deferredOrder}
            />;
        let dialogContent =
            <InitialSelector
                hideSelector={this.closeServiceTypeSelector}
                postServiceType={this.postServiceType}
                selectServiceType={this.selectServiceType}
                selectedServiceType={this.state.chosenServiceType}
                serviceTypes={this.state.serviceTypes}
                addressSelector={addressSelector}
                showAddressSelector={this.state.showAddressSelector}
            />;
        let curbsideInfo =
            <div className={"container text-center"}>
                <h5 className={"mt-1"}>Please Provide Your SMS Capable Number</h5>
                <small>We'll text you with a link for curbside.</small>
                {this.state.sms_error &&
                    <div className="alert alert-danger" role="alert">
                        {this.state.sms_error}
                    </div>
                }
                <div className="input-group mb-3 mt-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text store-bg-primary"><i className={"fa fa-mobile-alt"} style={{color: '#fff'}}></i></span>
                    </div>
                    <input type="text" className="form-control" id={"curbside_sms"} placeholder="Enter Mobile Number" aria-label="Enter Mobile Number" aria-describedby="curbside_go_button" onChange={this.updateCurbsideSms} />
                    <div className="input-group-append">
                        <button className="btn btn-outline-success" type="button" id="curbside_go_button" onClick={this.completeCurbside} disabled={!this.state.curbsideNextButtonEnabled}>Next</button>
                    </div>
                </div>
            </div>;
        let jsx = (
            <div>
                <div ref={this.modalRef} className="modal" tabIndex="-1" role="dialog" data-backdrop='static' id='serviceTypePanel'>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            {this.state.showSelectorButtons && dialogContent}
                            {this.state.showCurbsideInfo && curbsideInfo}
                            {this.state.isFutureOrder && deferredOrder}
                            <div className="w-100 clear">
                                {this.state.cancelButtonEnabled && <button onClick={() => { window.history.back() }} className='btn btn-secondary m-3 place-right'>Back</button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        let errorCloseFunction = this.state.hasServerError ? () => {document.location.reload()} : this.resetServiceTypeSelector;
        let errorCloseText = 'Select Another Service Type';
        return <RecurveBaseComponent errorCloseFunction={errorCloseFunction} errorCloseText={errorCloseText} hasPopupError={this.state.hasPopupError} loading={this.state.fetching} error={this.state.error} hasServerError={this.state.hasServerError} content={jsx} />
    }
}
